import React from "react";
import cx from "classnames";

import { formatAuditTrailInfo } from "../../utils/formatAuditTrailInfo";

import { StyledAuditTrail, StyledAuditTrailError } from "./styled";

export const AuditTrail = ({ prospectOverview = {} }) => {
  const auditTrailInfo = formatAuditTrailInfo(prospectOverview.AuditTrailInfo);

  return auditTrailInfo.length ? (
    <StyledAuditTrail>
      <div className={"applicationRow"}>
        <div className={cx("checkListData", "heading")}>Modified By</div>
        <div className={cx("checkListData", "heading")}>Modified On</div>
      </div>
      {auditTrailInfo.map((item, index) => (
        <div className={"applicationRow"} key={index}>
          <div className={"checkListData"}>{item.modifiedBy}</div>
          <div className={"checkListData"}>{item.modifiedDateTime}</div>
        </div>
      ))}
    </StyledAuditTrail>
  ) : (
    <StyledAuditTrailError>Fields are not modified yet.</StyledAuditTrailError>
  );
};
